import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Button, Heading } from '../../atoms';
import { ResponsiveImage } from '../../components';
import {
  BodyText,
  ButtonContainer,
  Content,
  Container,
  HeroTitle,
  ImageContainer,
  ImageWrapper,
} from './styles';

export const VetServices = ({
  bodyText,
  ctaButtonText,
  heroTitle,
  image,
  onCtaClick,
  title,
}) => {
  const hashRef = useRef();
  const { asPath } = useRouter();

  useEffect(() => {
    if (asPath?.endsWith('#OllieHealth')) {
      hashRef.current?.scrollIntoView();
    }
  }, [asPath, hashRef]);

  return (
    <>
      <span ref={hashRef} />
      <Heading headingLevel="h3" typography="heading1" headingText={title} />
      <Container>
        <ImageContainer>
          <ImageWrapper>
            <ResponsiveImage {...image} />
          </ImageWrapper>
        </ImageContainer>
        <Content>
          <HeroTitle>{heroTitle}</HeroTitle>
          <BodyText>{bodyText}</BodyText>
          <ButtonContainer>
            <Button fullWidth onClick={onCtaClick}>
              {ctaButtonText}
            </Button>
          </ButtonContainer>
        </Content>
      </Container>
    </>
  );
};

VetServices.displayName = 'VetServices';
VetServices.propTypes = {
  bodyText: PropTypes.node.isRequired,
  ctaButtonText: PropTypes.string.isRequired,
  heroTitle: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
